<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    t="1719131877152"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="25045"
    width="200"
    height="200">
    <path
      d="M89.014857 156.891429a62.683429 62.683429 0 0 0-15.872 41.691428v626.834286a62.683429 62.683429 0 0 0 62.683429 62.756571h752.347428a62.683429 62.683429 0 0 0 62.683429-62.683428V323.949714a62.683429 62.683429 0 0 0-62.683429-62.756571H613.449143a62.683429 62.683429 0 0 1-56.027429-34.669714l-28.086857-56.027429-3.949714-6.729143a62.683429 62.683429 0 0 0-52.150857-27.940571H135.826286l-7.314286 0.438857a62.683429 62.683429 0 0 0-39.497143 20.626286z m545.865143 351.085714h34.816a33.206857 33.206857 0 0 1 21.504 8.045714 25.088 25.088 0 0 1 8.923429 19.382857v199.972572c0 15.140571-13.604571 27.355429-30.354286 27.355428H354.304c-16.822857 0-30.354286-12.214857-30.354286-27.355428V535.332571c0-3.657143 0.731429-7.168 2.267429-10.532571a27.428571 27.428571 0 0 1 6.582857-8.923429 33.206857 33.206857 0 0 1 21.504-8.045714h34.742857v-72.996571c0-29.403429 13.019429-57.636571 36.059429-78.409143A130.121143 130.121143 0 0 1 512 324.022857c32.621714 0 63.853714 11.702857 86.893714 32.548572 23.04 20.772571 35.986286 49.005714 35.986286 78.409142v73.069715z m-105.837714 176.274286v-43.666286a33.645714 33.645714 0 0 0 20.699428-30.281143c0-18.870857-16.896-34.084571-37.741714-34.084571a40.374857 40.374857 0 0 0-23.405714 7.314285 33.865143 33.865143 0 0 0-13.312 18.797715 31.012571 31.012571 0 0 0 2.486857 22.162285 35.84 35.84 0 0 0 17.188571 16.091429v43.666286c0 0.950857 0.438857 1.901714 1.170286 2.56 0.731429 0.731429 1.755429 1.024 2.852571 1.024h26.112a4.242286 4.242286 0 0 0 2.779429-1.024 3.437714 3.437714 0 0 0 1.170286-2.56z m-92.745143-176.274286h151.405714V436.662857c0-37.741714-33.938286-68.461714-75.629714-68.461714-41.764571 0-75.776 30.72-75.776 68.388571v71.314286z"
      fill="#3282FF"
      p-id="25046" />
  </svg>
</template>

<script>
export default {
  name: 'JmDirIcon',
}
</script>

<style></style>
